import { Typography } from "@/design-system/Atoms";
import { LinkArrowButton } from "@/design-system/Atoms/Button/LinkButton";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";

export const AboutUsHowItWorksSection = () => {
  const { ctaButtonConfig, patientEntitlementsIsLoading } =
    usePatientCTAButtonConfig("Get Started");
  return (
    <section
      className="relative block w-full h-full py-[75px] lg:py-[160px] mt-40  bg-[#f6f6f4] 
             bg-[url('/images/bg-shape-2.svg')] bg-cover 
             bg-no-repeat 
             bg-center 
             rounded-t-[60px] 
             border-b-[12px] 
           border-[#d1f99c]"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap">
          <div className="w-full lg:w-5/12 ">
            <Typography variant="categoryText" as="div" className="mb-10">
              How it Works
            </Typography>
            <Typography variant="sectionHeading" as="h2" className="mb-10">
              <>
                Defy Medical’s streamlined process allows you to access ED
                medications simply and discreetly online.
              </>
            </Typography>
            <Typography
              variant="sectionDescriptionLarge"
              as="p"
              className="mb-10"
            >
              First, you’ll submit a simple health questionnaire. Our
              experienced care team is on hand to review your medical history
              and symptoms to see which ED medications are right for you. Then
              you can order your medications (if prescribed) and have them
              delivered in plain packaging to your door.
            </Typography>
            <Typography
              variant="sectionDescriptionSmall"
              as="p"
              className="mb-10"
            >
              If you want extra support, you can book a one-on-one consultation
              with a Defy Medical provider to discuss your needs.
            </Typography>
            <Typography variant="sectionDescriptionSmall" as="p">
              Take your first step toward better intimacy by filling out our
              simple health questionnaire now.
            </Typography>

            <LinkArrowButton
              href=""
              label={ctaButtonConfig.text}
              onClick={ctaButtonConfig.action}
              loading={patientEntitlementsIsLoading}
              className="mt-10 "
            />
          </div>
          <div className="w-full lg:w-1/2  lg:ml-[8.333333%]">
            <div className="sticky top-0 mb-[3.125rem]">
              <div>
                <img
                  className="w-full object-cover rounded-[20px]"
                  src="/images/about-us/feebfc47621805acd85877fd1b0b5456.jpg"
                  alt="About Us-How It Works"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsHowItWorksSection;
